export interface GroupLabel {
  id: string
  name: string
  namespaceId?: string
  namespaceName?: string
}

export function groupLabel(group: GroupLabel): string {
  return group.namespaceName ? `${group.namespaceName} / ${group.name}` : group.name
}
